import {
    AccountingReportComparison,
    AccountingReportComparisonDiff,
    AccountingReportCycle,
    AccountingReportRatioType,
} from "@common/constants";
import { AccountingReportType } from "@common/types/reports/report-type";

export const REPORT_PACKAGE_REPORT_TYPES = [
    AccountingReportType.PROFIT_LOSS,
    AccountingReportType.BALANCE_SHEET,
    AccountingReportType.TRIAL_BALANCE,
    AccountingReportType.GENERAL_LEDGER,
    AccountingReportType.EXPENSE_BY_VENDOR,
    AccountingReportType.CASH_FLOW_STATEMENT,
    AccountingReportType.AR_AGING_SUMMARY,
    AccountingReportType.AR_AGING_DETAIL,
] as const;

export const AR_AGING_REPORT_PACKAGE_REPORT_TYPES: ReportPackageReportType[] = [
    AccountingReportType.AR_AGING_SUMMARY,
    AccountingReportType.AR_AGING_DETAIL,
];

export function isArAgingReportPackageType(
    reportType: AccountingReportType,
): boolean {
    return AR_AGING_REPORT_PACKAGE_REPORT_TYPES.some(
        (type) => type === reportType,
    );
}

export const REPORT_PACKAGE_MAX_ROWS = 15;
export const REPORT_PACKAGE_MAX_ENTITIES = 50;

export type ReportPackageReportType =
    (typeof REPORT_PACKAGE_REPORT_TYPES)[number];

export type ReportPackageRowReportType =
    | ReportPackageReportType
    | AccountingReportType.SCHEDULES;

export function isAccrualReportPackageType(
    reportType: AccountingReportType,
): boolean {
    return (
        isArAgingReportPackageType(reportType) ||
        reportType === AccountingReportType.SCHEDULES
    );
}

export interface ReportPackageReportSetting {
    cycle?: AccountingReportCycle;
    comparisons?: AccountingReportComparison[];
    comparisonDiffs?: AccountingReportComparisonDiff[];
    ratioTypes?: AccountingReportRatioType[];
}

export const REPORT_PACKAGE_CYCLE_SUPPORTED: Set<AccountingReportType> =
    new Set([
        AccountingReportType.PROFIT_LOSS,
        AccountingReportType.BALANCE_SHEET,
        AccountingReportType.TRIAL_BALANCE,
        AccountingReportType.EXPENSE_BY_VENDOR,
        AccountingReportType.CASH_FLOW_STATEMENT,
    ]);
